import React, { useState } from 'react';
import { products } from '../data/products';
import ProductGrid from '../components/collection/ProductGrid';
import SEO from '../components/seo/SEO';
import './CollectionPage.css';

const fragrances = products.filter((p) => p.category === 'fragrance');

const FragrancePage: React.FC = () => {
  const [sortBy, setSortBy] = useState<string>('featured');

  return (
    <div className="collection-page">
      <SEO
        title="Fragrance Collection"
        description="Handmade natural perfume and cologne oils by Micah Lynise. Small-batch, clean ingredients, crafted in Texas."
        path="/fragrance"
      />
      {/* Breadcrumb */}
      <nav className="collection-page__breadcrumb" aria-label="Breadcrumb">
        <span>Home</span>
        <span aria-hidden="true"> / </span>
        <span>Fragrance</span>
      </nav>

      {/* Header */}
      <header className="collection-page__header">
        <h1 className="collection-page__title">Fragrances</h1>
        <p className="collection-page__subtitle">
          Handcrafted natural perfumes inspired by emotion, memory, and the beauty of imperfection.
        </p>
      </header>

      {/* Toolbar: product count + sort */}
      <div className="collection-page__toolbar">
        <span className="collection-page__count">{fragrances.length} products</span>
        <div className="collection-page__sort">
          <label htmlFor="sort-select" className="collection-page__sort-label">Sort by</label>
          <select 
            id="sort-select" 
            className="collection-page__sort-select"
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
          >
            <option value="featured">Featured</option>
            <option value="newest">Newest</option>
            <option value="price-asc">Price: Low to High</option>
            <option value="price-desc">Price: High to Low</option>
          </select>
        </div>
      </div>

      {/* Product grid: 2 columns */}
      <ProductGrid products={fragrances} columns={2} />
    </div>
  );
};

export default FragrancePage;
